import { Box } from '@mantine/core';
import { STANDARD_SIDEBAR_WIDTH } from './useDragAnimation';

const SIDEBAR_TRANSITION = 'flex-grow 0.35s ease, flex-basis 0.35s ease, opacity 0.2s ease-out';
const INNER_COLLAPSE_TRANSITION = 'transform 0.25s ease-out';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  width: number;
  isDragging?: boolean;
  collapsed?: boolean;
  fullScreen?: boolean;
};

export function AppSidebar({ children, style, width, isDragging, collapsed, fullScreen }: Props) {
  return (
    <Box
      h="100%"
      pos="relative"
      display="flex"
      style={{
        backgroundColor: 'rgba(255, 119, 28, 0.4)',
        borderRadius:
          'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
        transition: isDragging ? 'none' : SIDEBAR_TRANSITION,
        overflow: 'hidden',
        flexGrow: fullScreen ? 1 : 0,
        flexShrink: 0,
        flexBasis: fullScreen || collapsed ? 0 : width,
        opacity: collapsed ? 0 : 1,
        ...style,
      }}
    >
      <Box
        h="100%"
        w="100%"
        pos="relative"
        style={{
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          transition: isDragging ? 'none' : INNER_COLLAPSE_TRANSITION,
          minWidth: fullScreen ? undefined : `${STANDARD_SIDEBAR_WIDTH}px`,
          transform: collapsed ? 'translateX(100%)' : 'translateX(0)',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
